import { ProofOfService } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { BaseStateExtension } from '@common/state/state-extension';
import { ProofOfServiceModelName } from 'src/app/shared/models/model-names';

export const SERVICES_PROOF_OF_SERVICE_TAB_STATE_NAME = 'ServicesProofOfServiceTabState';

@Injectable({ providedIn: 'root' })
export class ProofOfServiceStateExtension extends BaseStateExtension<ProofOfService> {
  public name = ProofOfServiceModelName;
  public patientIdToObserve: string | null = null;

  public async canBeStored(item: ProofOfService): Promise<boolean> {
    if (!item || item.archived) {
      return false;
    }

    return item.patientId === this.patientIdToObserve;
  }

  protected async afterCreateInternal(item: ProofOfService) {
    await this.stateRegistry.createBySync(ProofOfServiceModelName, SERVICES_PROOF_OF_SERVICE_TAB_STATE_NAME, item);
  }

  protected async afterUpdateInternal(item: ProofOfService) {
    await this.stateRegistry.updateBySync(ProofOfServiceModelName, SERVICES_PROOF_OF_SERVICE_TAB_STATE_NAME, [item]);
  }

  protected async removeFromState(item: ProofOfService) {
    await this.stateRegistry.removeBySync(ProofOfServiceModelName, SERVICES_PROOF_OF_SERVICE_TAB_STATE_NAME, [item]);
  }
}
